import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractCancellation.List.IRequest;
type Response = Api.Core.ContractCancellation.List.IResponse;
type Headers = Api.Core.ContractCancellation.List.IHeaders;
const url = '/api/Sales/ContractCancellation';
export default async function contractCancellationListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
